import styled from 'styled-components';
import { Box, Stack, Text } from '@lessonnine/design-system.lib';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

export const OauthContainer = styled(Stack)`
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    max-width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    max-width: 21rem;
  }
`;

export const OauthSeparator = styled(Box)`
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.color.surface.foreground.secondary};
  width: 50%;
  padding-top: 0.25rem;
`;

export const OauthSeparatorText = styled(Text)`
  min-width: 6.25rem;
`;

export const PrivacyTerms = styled(Box)`
  align-self: center;
  font-size: ${tokens.size.font.xsmall};
  margin-top: 1rem;
  text-align: center;

  @media only screen and ${devices.fromxxsmall} {
    width: 21.5rem;
  }

  @media only screen and ${devices.fromxsmall} {
    width: 26rem;
  }

  @media only screen and ${devices.fromsmall} {
    width: 24.75rem;
  }
`;
